module.exports = "<div class=\"stick-block-ui\" [ngClass]=\"visibleStyle\">\n  <div class=\"stick-block-ui-body\" >\n    <ng-content></ng-content>\n    {{ItemStick}}\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/components/stiks/stick.template.html
// module id = ../../../../../src/app/components/stiks/stick.template.html
// module chunks = main